import { render, staticRenderFns } from "./CreateApprovalRequest.vue?vue&type=template&id=2ba9cbdc"
import script from "./CreateApprovalRequest.vue?vue&type=script&lang=js"
export * from "./CreateApprovalRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports